export const Data = [
{
    id: 1,
    name: 'Face mask',
    category: "cloths",
    price: 300,
    description: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui do lorem ipsum,',
    inCart: false,
    img: './images/mask.jpg',
    qty: 8,
    count : 0,
    total: 0
    
},
{
    id: 2,
    name: 'Beautiful lingeries',
    category: "lingeries",
    price:250,
    description: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui do lorem ipsum,',
    inCart: false,
    img: './images/lingeries.jpg',
    qty: 20,
    count : 0,
    total: 0
},
{
    id: 3,
    name: 'beautiful panties',
    category: "panties",
    price: 120,
    description: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui do lorem ipsum,',
    inCart: false,
    img: './images/pants.jpg',
    qty: 6,
    count : 0,
    total: 0
},
{
    id: 4,
    name: 'sweet bread',
    category: "bread",
    price: 500,
    description: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui do lorem ipsum,',
    inCart: false,
    img: './images/bread.jpg',
    qty: 5,
    count : 0,
    total: 0
},
{
    id: 5,
    name: 'Television set',
    category: "television",
    price: 1000,
    description: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui do lorem ipsum,',
    inCart: false,
    img: './images/television.jpg',
    qty: 10,
    count : 0,
    total: 0
}
];

export const DetailData = {
        id: 1,
        name: 'Face mask',
        category: "cloths",
        price: 300,
        description: 'Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui do lorem ipsum,',
        inCart: false,
        img: './images/mask.jpg',
        qty: 8,
        count : 0,
        total: 0
    }

